import styled from 'styled-components';

import { colors } from 'theme';

export const SignatureContainer = styled.div<{ $error: boolean }>`
  border: ${({ $error }) => ($error ? `2px solid ${colors.error.light}` : `1px solid ${colors.action.disabledBackground}`)};
  border-radius: 4px;
  margin-bottom: 4px;
  min-height: 190px;
  width: 100%;
  position: relative;
`;

export const Placeholder = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${colors.text.secondary};
  font-size: 16px;
  pointer-events: none;
`;
